import React, { useEffect } from "react";
import { Flex } from "theme-ui";
import { StaticImage } from "gatsby-plugin-image";
import { Parallax, ParallaxBanner } from "react-scroll-parallax";
import { BannerLayer } from "react-scroll-parallax/dist/components/ParallaxBanner/types";
import { useSecureLinks } from "../hooks/useSecureLinks";
import sal from "sal.js";

interface Props {}

const HomeHeroParallax = (props: Props) => {
  const mobileHeight = 750;
  const secureLinks = useSecureLinks();
  useEffect(() => {
    setTimeout(() => {
      sal();
    }, 1000);
  }, []);
  return (
    <div
      sx={{
        height: [mobileHeight, null, null, null, 630, "632px"],
        overflow: "hidden",
        background: "url(/images/HomeBackgroundBlank.webp);",
        backgroundSize: "cover",
      }}
    >
      <ParallaxBanner
        data-sal="fade-in"
        data-sal-duration="500"
        data-sal-easing="easeOutQuart"
        layers={[
          {
            image: "/images/BuildingBkg.webp",
            translateY: [-50, 40],
            className: "layer1",
            style: {
              width: "100%",
              backgroundSize: "cover",
              backgroundPosition: "0px 40%",
              backgroundRepeat: "no-repeat",
              top: 0,
              height: "700px",
            },
          },
        ]}
      >
        <div
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ParallaxBanner
            data-sal="fade-in"
            data-sal-delay="50"
            data-sal-duration="500"
            data-sal-easing="easeOutQuart"
            sx={{
              display: ["none", null, null, "block"],
              ".layer1": {},
              maxWidth: 1920,
            }}
            layers={[
              // {
              //   image: "/images/BuildingBkg.webp",
              //   translateY: [-50, 40],
              //   className: "layer1",
              //   style: {
              //     width: "100%",
              //     backgroundSize: "cover",
              //     backgroundPosition: "0px 40%",
              //     backgroundRepeat: "no-repeat",
              //     top: 0,
              //     height: "750px",
              //   },
              // },
              {
                image: "/images/Lady_Swirl.png",
                className: "layer2",
                translateY: [20, -20],
                style: {
                  width: "100%",
                  maxWidth: 1680,
                  top: "2.6vw",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center top",
                  height: "832px",
                },
              },
            ]}
          >
            <div
              sx={{
                display: ["flex", null, null, "flex"],
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                width: ["100%", null, null, "100%"],
                top: 40,
                // left: ["50%", null, null, "10%", "15%", "17%"],
                transform: ["translate(-50%, -50%)", null, null, "none"],
                height: [745],
              }}
            >
              {/* <Parallax speed={30}> */}
              <div
                sx={{
                  display: ["flex", null, null, "block"],
                  flexDirection: "column",
                  justifyContent: ["space-between", null, null, "center"],
                  alignItems: "center",
                  height: ["100%"],
                  mt: ["90px"],
                  position: "relative",
                  maxWidth: 1360,
                  width: "100%",
                  px: [4],
                }}
              >
                <Flex
                  sx={{
                    flexDirection: ["column"],
                    alignItems: ["center", null, null, "flex-start"],
                    // pt: ["286px", null, null, 0],
                    mt: [0, null, null, 4],
                  }}
                >
                  <h1
                    data-sal="slide-down"
                    data-sal-delay="0"
                    data-sal-duration="1000"
                    data-sal-easing="easeOutQuart"
                    sx={{
                      variant: "text.h1HeaderRegular",
                      maxWidth: [350, null, null, 500],
                      mt: [0, 4, null, 0],
                    }}
                  >
                    Ready, Set, Get Pre-Approved!
                  </h1>
                  <p
                    data-sal="slide-down"
                    data-sal-delay="100"
                    data-sal-duration="1000"
                    data-sal-easing="easeOutQuart"
                    sx={{
                      variant: "text.h2HeaderSemiBold",
                      maxWidth: [350, null, null, 550, 630],
                      pt: "22px",
                    }}
                  >
                    Discover your loan options without impacting
                    <br />
                    your credit score.<sup>§</sup>
                  </p>
                </Flex>
                <div
                  data-sal="slide-down"
                  data-sal-delay="200"
                  data-sal-duration="1000"
                  data-sal-easing="easeOutQuart"
                  sx={{
                    width: 212,
                  }}
                >
                  <a
                    href={secureLinks.loanApplication}
                    sx={{
                      variant: "buttons.newPrimary",
                      mt: "27px",
                      width: 212,
                      justifyContent: "flex-end",
                      mb: [4, null, null, 0],
                    }}
                  >
                    Get Pre-Approved
                  </a>
                </div>
              </div>
              {/* </Parallax> */}
            </div>
          </ParallaxBanner>
        </div>
      </ParallaxBanner>
      <div
        data-sal="fade-in"
        data-sal-delay="0"
        data-sal-duration="1000"
        data-sal-easing="easeOutQuart"
        sx={{
          display: ["flex", null, null, "none"],
          flexDirection: "column",
          justifyContent: "center",
          position: "relative",
          width: ["100%", null, null, "100%"],
          // top: [100],
          // left: ["0%", null, null, "8%", "10%", "15%"],
          // transform: ["translate(-50%, -50%)", null, null, "none"],
          height: mobileHeight,
          background: "url(/images/HomeBackgroundMobileTemp.webp);",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          sx={{
            display: ["flex", null, null, "block"],
            flexDirection: "column",
            justifyContent: ["flex-start", null, null, "center"],
            alignItems: "center",
            height: mobileHeight,
            // mt: ["140px"],
            mt: 4,
            position: "relative",
          }}
        >
          {/* <Parallax translateY={[-60, 0]}> */}
          <Flex
            sx={{
              flexDirection: ["column"],
              alignItems: ["flex-start", null, null, "flex-start"],
              // pt: ["286px", null, null, 0],
            }}
          >
            <h1
              data-sal="slide-down"
              data-sal-delay="0"
              data-sal-duration="1000"
              data-sal-easing="easeOutQuart"
              sx={{
                variant: "text.h1HeaderRegular",
                maxWidth: [350, null, null, 300],
                width: "100%",
                mt: [0, 3, null, 0],
              }}
            >
              Ready, Set, Get Pre-Approved!
            </h1>
            <p
              data-sal="slide-down"
              data-sal-delay="100"
              data-sal-duration="1000"
              data-sal-easing="easeOutQuart"
              sx={{
                variant: "text.h2HeaderSemiBold",
                maxWidth: [350, null, null, 550, 630],
                pt: "22px",
              }}
            >
              Discover your loan options without impacting your credit score.
              <sup>§</sup>
            </p>
          </Flex>
          {/* </Parallax> */}
          <div
            data-sal="slide-down"
            data-sal-delay="200"
            data-sal-duration="1000"
            data-sal-easing="easeOutQuart"
            sx={{
              width: 232,
              mt: 4,
            }}
          >
            <a
              href={secureLinks.loanApplication}
              sx={{
                variant: "buttons.newPrimary",
                position: "relative",
                width: "100%",
                justifyContent: "flex-end",
                mb: [4, null, null, 0],
              }}
            >
              Get Pre-Approved
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeHeroParallax;
